<template>
  <div class="footer-container">
    <div class="content" >
    <div class="left-content">
      <div class="footer-logo"></div>
      <div class="footer-content">
        <div class="footer-address">总部地址:安徽省合肥市高新区天鹅湖路29号通用院办公楼405室</div>
        <div class="footer-emial">邮箱:15309691517@163.com</div>
      </div>
    </div>
    <div class="right-content">
<!--      <div class="first-content footer-box">-->
<!--       <ul>-->
<!--         <li class="footer-a">产品服务</li>-->
<!--         <li @click="gotochangpin"><router-link to="/products/ict/service">系列产品</router-link></li>-->
<!--         <li @click="gotochangpin"><router-link to="/products/ict/service">专业服务</router-link></li>-->
<!--       </ul>-->
<!--      </div>-->
<!--      <div class="second-content footer-box">-->
<!--        <ul @click="gotochangpin">-->
<!--         <li class="footer-a">合作企业</li>-->
<!--         <li><router-link to="/cooperation/all">合作企业</router-link></li>-->
<!--       </ul>-->
<!--      </div>-->
      <div class="third-content footer-box">
         <ul @click="gotochangpin">
         <li class="footer-a" >关于我们</li>
         <li><router-link to="/company/introduction">公司简介</router-link></li>
         <li><router-link to="/company/development">发展历程</router-link></li>
         <li><router-link to="/company/culture">公司文化</router-link></li>
         <li><router-link to="/company/contact">联系我们</router-link></li>
       </ul>
      </div>
    </div>
    </div>
    <div class="footer-satament">法律声明  |  隐私保护 &nbsp;&nbsp;Copyright©2018 - 2023&nbsp;安徽中培智慧信息科技有限公司 版权所有
      <a  href="https://beian.miit.gov.cn/" target="_blank">皖ICP备2023017858号&nbsp;</a>
      <a  href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank">皖公网安备34010402704037号</a>
     </div>
  </div>
</template>

<script>
export default {
  methods: {
    gotochangpin() {
      window.scrollTo(0,450)
    }
  },
}
</script>

<style lang="less" scoped>
//统一底部文字大小 和文字样式
.footer-container {
  width: 19.2rem;
  font-size: 0.2rem;
  font-family: Source Han Sans CN;
}
.content {
height: 3.5rem;
background-color: #FAFAFB;
position: relative;
padding: 0 2.6rem;
margin-bottom: 0.2rem;
}
.left-content {
position: absolute;
text-align: left;
}
.right-content  {
  width: 5.22rem;
  height: 2.4rem;
  position: absolute;
  top: 0.45rem;
  left: 11.38rem;
  display: flex;
  justify-content: space-around;
}
.footer-logo {
  width: 2.4rem;
  height: 1.2rem;
  margin-top: 0.1rem;
  margin-bottom: 0.44rem;
  //background-image: url("../../assets/logo/zp_logo.jpg");
  background-image: url("../../assets/logo/zpzh_logo.png");
  background-repeat: no-repeat;
  background-size: 1.2rem;
}
.footer-address {
  width: 3.81rem;
  height: 0.71rem;
  margin-bottom: 0.1rem;
  font-size: 0.2rem;
  font-weight: 400;
  line-height: 0.4rem;
  color: #333333;
  opacity: 1;
}
.footer-emial {
  width: 2.8rem;
  height: 0.29rem;
  font-size: 0.2rem;
  font-weight: 400;
  line-height: 0.29rem;
  color: #333333;
}
//底部的右侧3个盒子
.footer-box {
  width: 1.34rem;
  height: 2.4rem;
}
.footer-a {
  font-size: 0.22rem;
  font-weight: 500;
  line-height: 0.33rem;
  color: #333333;
  margin-top: 0.25rem;
  margin-bottom: 0.2rem;
}
.footer-box ul {
  padding: 0;
  margin: 0;
}
.footer-box li {
  list-style-type: none;
}
.footer-box li a {
  text-decoration: none;
  font-size: 0.2rem;
  font-weight: 400;
  line-height: 0.35rem;
  color: #666666;
}
//定位这3个盒子
.first-content{
  background-image: url("../../assets/images_rectangle/组 109.png");
  background-repeat: no-repeat;
  background-size: 1.34rem 2.4rem;
}
.second-content {
  background-image: url("../../assets/images_rectangle/组 110.png");
  background-repeat: no-repeat;
  background-size: 1.34rem 2.4rem;
}
.third-content {
  background-image: url("../../assets/images_rectangle/组 111.png");
  background-repeat: no-repeat;
  background-size: 1.34rem 2.4rem;
}
.footer-satament {
  width: 15.44rem;
  height: 0.29rem;
  font-size: 0.2rem;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 0.29rem;
  color: #999999;
  margin-left: 3.4rem;
  margin-bottom: 0.1rem;
  position: relative;
  text-align: center;
}
.footer-satament span  {
  display: block;
  width: 0.2rem;
  height: 0.2rem;
  position: absolute;
  top: 0.05rem;
  left: 9.33rem;
  //background-image: url("../../assets/logo/footerlogo.png");
  background-repeat: no-repeat;
  background-size: 0.2rem 0.2rem;
}
</style>
